import { iconGlobe } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon, Link } from '../index.js';
export const LocaleSelectorTrigger = ({ className, country, hideOn = [], language, ...rest }) => (React.createElement("div", { className: cx('tds-card', 'tds-card--dense', 'tds-locale-selector-trigger', ...hideOn.map((value) => `tds--hideon-${value}`), className), role: "button", tabIndex: 0, ...rest },
    React.createElement(Icon, { data: iconGlobe }),
    React.createElement("div", { className: "tds-card-body" },
        React.createElement("div", null,
            React.createElement("strong", null, country)),
        React.createElement(Link, { className: "tds-text--caption", variant: "secondary" }, language))));
